module.exports = __webpack_public_path__ + "static/media/vignette_06.5afd44c6.png";